import { render, staticRenderFns } from "./KioskAttendReports.vue?vue&type=template&id=694461d3&"
import script from "./KioskAttendReports.vue?vue&type=script&lang=ts&"
export * from "./KioskAttendReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports